import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { CgChargeService } from '../../../services/simple/cg-charge.service';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { Form, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, OnChanges } from '@angular/core';
import { GestionCgChargeComponent } from 'src/app/core/gestion-referentiel/gestion-cg-charge/gestion-cg-charge.component';

export interface DialogData {
    form: UntypedFormGroup;
    cgCharges: CgChargeModel[];
    societeId: number;
    result: boolean;
  }
@Component({
    selector: 'app-modal-add-cg-charge',
    templateUrl: './modal-add-cg-charge.component.html',
    styleUrls: ['./modal-add-cg-charge.component.scss']
  })
  export class ModalAddCgChargeComponent implements OnInit {
    cgCharges: CgChargeModel[];
    form: UntypedFormGroup;
    constructor(public dialog: MatDialog
              , public dialogRef: MatDialogRef<GestionCgChargeComponent>
              , @Inject(MAT_DIALOG_DATA) public data: DialogData
              , private toastr: ToastrService
              , private router: Router
              , private cgChargeService: CgChargeService) {
               }

  ngOnInit(): void {
    this.cgCharges = this.data.cgCharges;
    this.form = this.data.form;
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const cg = this.form.getRawValue();
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.cgChargeService.save(cg).subscribe((a: CgChargeModel) => {
            this.toastr.success('', 'Création du CG Charge ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.cgChargeService.update(cg.id, cg).subscribe((a: CgChargeModel) => {
          this.toastr.success('', 'Modification du CG Charge ' + a.code + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
      this.toastr.warning('', 'Veuillez remplir les champs obligatoire');
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}

